import React, { Component } from 'react';
import {Route} from "react-router-dom";
import {organisationDetails} from "../../util/ApiUtils";
import TrainingRegister from "./TrainingRegister";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import {withStyles} from "@material-ui/styles";
import ApprovedSupplierList from "./ApprovedSupplierList";
import CalibrationSchedule from "./CalibrationSchedule";
import NonconformanceRegister from "./NonconformanceRegister";
import CommunicationPlan from "./CommunicationPlan";
import IncidentNotificationTemplate from "./IncidentNotificationTemplate";
import Msds from "./Msds";
import Swms from "./Swms";
import {Spinner} from "../common/Spinner";
import AuditPlan from "./AuditPlan";
import ManagementReviewMeeting from "./ManagementReviewMeeting";
import ImsAuditChecklist from "./ImsAuditChecklist";
import EmergencyResponseTesting from "./EmergencyResponseTesting";
import ApprovedContractors from "./ApprovedContractors";
import DocumentRetention from "./DocumentRetention";
import ImsImprovementRegister from "./ImsImprovementRegister";
import AssetRegisterForm from "./AssetRegisterForm";
import PrivilegedAccessForm from "./PrivilegedAccessForm";

const classes = () => ({
    card: {
        width: '100%',
    },
});

class Operation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            latestRevision: {},
            isLoading: true,
        };
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                this.setState({
                    organisation: response,
                    orgId: response.id,
                    latestRevision: response.latestRevisionDto,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    render() {
        let { state } = this;
        const { classes } = this.props;

        if (state.isLoading) {
            return <Spinner/>;
        }

        return <div className="mui-container-fluid">
                <Card className={classes.card}>
                    <CardHeader
                        title={
                            <p style={{color: "darkblue"}}><b>OPERATION</b></p>
                        }
                        subheader={
                            <span>
                            </span>
                        }
                    />
                    <CardContent>
                        <hr/>
                        <Route
                            path={`/operation/ims-improvement-register`}
                            render={() =>
                                <ImsImprovementRegister currentUser={this.props.currentUser}/>
                            }
                        />
                        <Route
                            path={`/operation/ims-audit-checklist`}
                            render={() =>
                                <ImsAuditChecklist currentUser={this.props.currentUser}/>
                            }
                        />
                        <Route
                            path={`/operation/management-review-meeting`}
                            render={() =>
                                <ManagementReviewMeeting currentUser={this.props.currentUser}/>
                            }
                        />
                        <Route
                            path={`/operation/approved-supplier`}
                            render={() =>
                                <ApprovedSupplierList currentUser={this.props.currentUser}/>
                            }
                        />
                        <Route
                            path={`/operation/approved-contractor`}
                            render={() =>
                                <ApprovedContractors currentUser={this.props.currentUser}/>
                            }
                        />
                        <Route path={`/operation/equipment-register`} component={undefined}/>
                        <Route path={`/operation/msds`}
                               render={() =>
                                   <Msds currentUser={this.props.currentUser}/>
                        }/>
                        <Route path={`/operation/audit-plan`}
                               render={() =>
                            <AuditPlan currentUser={this.props.currentUser}/>
                        }/>
                        <Route path={`/operation/noncomformance`}
                               render={() =>
                                   <NonconformanceRegister currentUser={this.props.currentUser}/>
                               }
                        />
                        <Route path={`/operation/swms`}
                               render={() =>
                                   <Swms currentUser={this.props.currentUser}/>
                               }
                        />
                        <Route path={`/operation/communication-plan`}
                               render={() =>
                                   <CommunicationPlan currentUser={this.props.currentUser}/>
                               }/>
                        <Route path={`/operation/incident-notification-template`}
                               render={() =>
                                   <IncidentNotificationTemplate currentUser={this.props.currentUser}/>
                               }/>
                        <Route path={`/operation/training-register`}
                               render={() =>
                                   <TrainingRegister currentUser={this.props.currentUser}/>
                               }/>
                        <Route path={`/operation/document-retention`}
                               render={() =>
                                   <DocumentRetention currentUser={this.props.currentUser}/>
                               }/>
                        <Route path={`/operation/emergency-response-testing`}
                               render={() =>
                                   <EmergencyResponseTesting currentUser={this.props.currentUser}/>
                               }/>
                        <Route path={`/operation/asset-register-form`}
                               render={() =>
                                   <AssetRegisterForm currentUser={this.props.currentUser}/>
                               }/>
                        <Route path={`/operation/privileged-access-form`}
                               render={() =>
                                   <PrivilegedAccessForm currentUser={this.props.currentUser}/>
                               }/>
                    </CardContent>
                </Card>
            </div>;
    }
}

export default withStyles(classes)(Operation);